import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { ACTIVE_STATUS, LOCKED_STATUS, VOUCHER_STATUS } from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
function HistoryServicePopup({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chỉnh sửa dịch vụ"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataHistory?.content}
            name="HistoryService"
            showMoreButton
            minWidth={"1000"}
            columns={[
              {
                title: t("Mã đơn hàng"),
                field: "code",
              },
              {
                field: "service.tradeName",
                title: t("Dịch vụ"),
                render: (row) => {
                  let percent =
                    (+row?.totalPerformedTimes * 100) /
                    +row?.totalTreatmentTimes || 0;
                  return (
                    <div className="pl-1 pr-1">
                      <div>
                        <span className="service-code">
                          {row?.service?.code}
                        </span>{" "}
                        <span className="service-name">
                          {row?.service?.tradeName}
                        </span>
                      </div>
                      <div class="fancy-progress-wrapper mt-1">
                        <div class="fancy-progress-text">
                          {row?.totalPerformedTimes} |{" "}
                          {row?.totalTreatmentTimes}
                        </div>
                        <div class="fancy-progress-bar">
                          <div
                            class="fancy-progress-fill"
                            style={{ width: `${percent}%` }}
                          ></div>
                        </div>
                      </div>
                      <div className="flex mt-2">
                        <div>
                          Đã thu:{" "}
                          <b style={{ color: "green" }}>
                            {formatMoney(row?.totalBillPatientPaid || 0)}
                          </b>
                        </div>
                        <span className="mx-2 text-gray-400">|</span>
                        <div>
                          Cần thu:{" "}
                          <b style={{ color: "red" }}>
                            {formatMoney(row?.amountActuallyPaid)}
                          </b>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                field: "practitioner.staffName",
                title: t("Giá"),
                render: (row) => formatMoney(row?.price),
                align: "right",
              },
              {
                field: "quantity",
                title: t("SL đăng ký ban đầu"),
                align: "right",
              },
              {
                field: "remainingTreatmentTimes",
                title: t("SL sau đổi"),
                align: "right",
              },
              {
                field: "practitioner.staffName",
                title: t("Thành tiền"),
                width: "240px",
                render: (data) => {
                  return (
                    <div className="total-data-group">
                      <div className="flex justify-between">
                        Thành tiền:{" "}
                        <b>{formatMoney(data?.price * data?.quantity)}</b>
                      </div>
                      <div className="flex justify-between">
                        Giảm giá: <b>{formatMoney(data?.discount)}</b>
                      </div>

                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Số tiền (sau giảm):{" "}
                          <b>
                            {formatMoney(
                              data?.price * data?.quantity -
                              (+data?.discount || 0)
                            )}
                          </b>
                        </b>
                      </div>
                      <div className="flex justify-between">
                        Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                      </div>
                      <div
                        style={{
                          background: "#ccc",
                          width: "100%",
                          height: "1px",
                          margin: "4px 0",
                        }}
                      ></div>
                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Tổng thanh toán:{" "}
                          <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                        </b>
                      </div>
                      {data?.allocateDiscount ? (
                        <div>
                          <b
                            className="flex justify-between"
                            style={{ width: "100%" }}
                          >
                            Giảm tổng HĐ:{" "}
                            <b>{formatMoney(data?.allocateDiscount)}</b>
                          </b>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                },
              },
              {
                field: "clientCard.name",
                title: t("Ngày đăng ký"),
                render: (val) => getDateTime(val?.orderDate),
              },
              {
                field: "clientCard.name",
                title: t("Liệu trình"),
                render: (val) => val?.treatmentPlanCard?.name,
              },

              {
                field: "createdBy",
                title: t("Người tạo"),
              },
              {
                field: "modifiedBy",
                title: t("Người sửa"),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },
              {
                field: "department.name",
                title: t("Cơ sở"),
              },

              {
                field: "activeStatus",
                title: t("Trạng thái"),
                render: (row) => (
                  <div style={{ textAlign: "center" }}>
                    {row?.activeStatus === ACTIVE_STATUS ? (
                      <Tooltip title="Đang mở">
                        <LockOpenIcon />
                      </Tooltip>
                    ) : row?.activeStatus === LOCKED_STATUS ? (
                      <Tooltip title="Đã khóa">
                        <LockIcon />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                ),
              },
              {
                field: "lockDate",
                title: t("Ngày khóa"),
                render: (row) => getDateTime(row?.lockDate),
              },
              {
                field: "note",
                title: t("Ghi chú"),
              },
              {
                field: "oldPatientServiceRegister",
                title: t("DV/SP cũ"),
                render: (val) =>
                  val?.oldPatientServiceRegister?.name ||
                  val?.oldDrugOrder?.name,
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataHistory?.totalElements,
              totalPages: pageDataHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryServicePopup));
